import { BookOpen, Home, User } from 'lucide-react';
import { useGlobalState } from '@/stores/globalState';
import { useIsDesktop } from '@/hooks/useMediaQuery';
import type { AppModule } from '@/types';

// Mirrors the sidebar's module mapping (Home = guides, Profile =
// placement). Learning Journey is hidden on mobile while "Coming soon".
import { CssVarButton, CssVarNav, CssVarSpan } from "@/components/CssVarElements";const NAV_ITEMS: {
  module: AppModule;
  label: string;
  icon: React.ComponentType<{className?: string;}>;
}[] = [
{ module: 'MY_GUIDES', label: 'Home', icon: Home },
{ module: 'EVALUATION', label: 'Profile', icon: User },
{ module: 'BOOKS', label: 'Books', icon: BookOpen }];


export function MobileBottomNav() {
  const isDesktop = useIsDesktop();
  const activeModule = useGlobalState((s) => s.activeModule);
  const setActiveModule = useGlobalState((s) => s.setActiveModule);

  if (isDesktop) {
    return null;
  }

  return (
    <CssVarNav
      className="hs-brand fixed bottom-0 left-0 right-0 z-30 flex h-16 items-center justify-around"
      cssVars={{ borderTop: '1px solid var(--line)' }}>

      {NAV_ITEMS.map(({ module, label, icon: Icon }) => {
        const isActive = activeModule === module;
        return (
          <CssVarButton
            key={module}
            type="button"
            onClick={() => setActiveModule(module)}
            className="flex flex-1 flex-col items-center justify-center gap-0.5 py-2"
            cssVars={{
              background: 'transparent',
              border: 'none',
              color: 'var(--ink)',
              opacity: isActive ? 1 : 0.55,
              fontFamily: 'var(--f-body)',
              fontWeight: isActive ? 800 : 600
            }}>

            <CssVarSpan cssVars={{ display: 'flex', color: isActive ? 'var(--coral)' : 'inherit' }}>
              <Icon className="h-5 w-5" />
            </CssVarSpan>
            <span className="text-[10px]">{label}</span>
          </CssVarButton>);

      })}
    </CssVarNav>);

}
